<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="招生人员"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="aform">
        <el-form-item label="姓名" required prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>

        <el-form-item label="登录账号" required prop="login_name">
          <el-input v-model="form.login_name" placeholder="登录账号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" required prop="pwd">
          <el-input v-model="form.pwd" placeholder="登录密码"></el-input>
          <p>8-20位，必须包含数字和字母</p>
        </el-form-item>
        <el-form-item label="电话" required prop="mobile">
          <el-input v-model="form.mobile" placeholder="电话"></el-input>
        </el-form-item>
        <el-form-item label="省市区">
          <city-select @change="changeCity" :temp="cityList"></city-select>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="form.address">
            <addr-select
              slot="append"
              @getform="addMecAddr"
              type="icon"
            ></addr-select>
          </el-input>
        </el-form-item>
        <el-form-item label="经度">
          <el-input v-model="form.longitude" placeholder="经度"></el-input>
        </el-form-item>
        <el-form-item label="纬度">
          <el-input v-model="form.latitude" placeholder="纬度"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      if_clear: true,
      cityList:[]
    };
  },

  methods: {
    // 地址
    addMecAddr(addr) {
      if (addr.address) {
        this.$set(this.form, "province", addr.province);
        this.$set(this.form, "city", addr.city);
        this.$set(this.form, "district", addr.district);
        this.$set(this.form, "address", addr.address);
        this.cityList = [];
        this.cityList.push(addr.province);
        this.cityList.push(addr.city);
        this.cityList.push(addr.district);
      }

      this.$set(this.form, "latitude", addr.addrPoint.lat);
      this.$set(this.form, "longitude", addr.addrPoint.lng);
    },
    changeCity(v) {
      this.cityList = v;
      this.form.province = v[0];
      this.form.city = v[1];
      this.form.district = v[2];
    },
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
        this.cityList = [];
        this.cityList.push(info.province);
        this.cityList.push(info.city);
        this.cityList.push(info.district);
        if (info.map.space) {
          this.curSpace = info.map.space.name;
        } else {
          this.curSpace = "";
        }
      } else {
        this.form = {};
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.aform.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.aform.validate((valid) => {
        if (valid) {
         if (!this.validPwd(this.form.pwd)) {
            return;
          }
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/authorization/managerUser/insert";
      this.if_clear = false;
      this.form.type = "enroll";
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.if_clear = true;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      this.if_clear = false;
      let url = "/authorization/managerUser/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.if_clear = true;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },

    validPwd(pwd) {
      let regex = /(?=.*[0-9])(?=.*[a-zA-Z]).{8,16}/;

      if (regex.test(pwd)) {
        return true;
      }
      this.$message("密码格式不正确");
      return false;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>